const Home = () => {
    return(
        <>
            <h1>HOME</h1>
        </>
    )
}

export default Home